import React from "react";
import moment from "moment";
import {
  Typography,
  CardContent,
  Card,
  Badge,
  withStyles,
  Switch,
} from "@material-ui/core";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import styles from "./notification.module.scss";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textArea";
import { Checkbox } from "../../components/ui/checkbox";
import { cn } from "../../components/ui/utils";
import { AlertTriangle, Info, MessageSquare } from "lucide-react";

const RecipientType = ({ recipientType }) => {
  switch (recipientType) {
    case "employee":
      return (
        <PersonOutlineOutlinedIcon
          style={{ color: "rgb(59 130 246 / 1)" }}
          fontSize=""
        />
      );
    case "client":
      return (
        <ApartmentOutlinedIcon
          fontSize=""
          style={{ color: "rgb(34 197 94 / 1)" }}
        />
      );
    case "group":
      return (
        <GroupOutlinedIcon
          fontSize=""
          style={{ color: "rgb(168 85 247 / 1)" }}
        />
      );
    default:
      return (
        <PersonOutlineOutlinedIcon
          style={{ color: "rgb(59 130 246 / 1)" }}
          fontSize=""
        />
      );
  }
};

const RecipientList = ({
  options,
  formdata,
  recipientType,
  handlefieldChange,
  selectedRecipients,
}) => {

  const handleRecipientSelect = (recipient) => {
    if (recipientType === "employee") {
      let newSelected = [...(formdata?.selectedEmployees || [])];
      const exists = newSelected?.find((r) => r.id === recipient.value.id);

      if (exists) {
        newSelected = newSelected?.filter((r) => r.id !== recipient.value.id);
      } else {
        newSelected.push(recipient.value);
      }
      handlefieldChange("selectedEmployees", newSelected);
    } else if (recipientType === "group") {
      let newSelected = [...(formdata?.selectedGroup || [])];
      const exists = newSelected?.find((g) => g?.groupId === recipient?.value?.groupId);

      if (exists) {
        newSelected = newSelected?.filter((g) => g?.groupId !== recipient?.value?.groupId);
      } else {
        newSelected.push(recipient.value);
      }
      handlefieldChange("selectedGroup", newSelected);
    }
  };


const handleSelectAll = (options) => {
  const allSelected = options?.map((item) => item.value);

  if (recipientType === "employee") {
    const isAllSelected = formdata?.selectedEmployees?.length === options?.length;
    handlefieldChange("selectedEmployees", isAllSelected ? [] : allSelected);
  } else if (recipientType === "group") {
    const isAllSelected = formdata?.selectedGroup?.length === options?.length;
    handlefieldChange("selectedGroup", isAllSelected ? [] : allSelected);
  }
};

  const isSelected = (recipient) => {
    if (recipientType === "employee") {
      return selectedRecipients?.some(
        (r) => r?.id === (recipient?.value?.id || recipient?.id)
      );
    } else if (recipientType === "group") {
      return selectedRecipients?.some(
        (r) => r?.groupId === (recipient?.value?.groupId || recipient?.groupId)
      );
    }
    return false;
  };
  return (
    <div className={`${styles.listContainer} dark:border-0  dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] `}>
      {options?.length > 0 ? (
        <>
          <div
            className={styles.selectAll}
            onClick={() => handleSelectAll(options)}
          >
            <span className="font-medium dark:text-[#6B7280]">Select All</span>
            <Badge
              variant={
                options.every((opt) => isSelected(opt)) ? "success" : "outline"
              }
            >
              <span className="dark:text-white">{options?.filter((opt) => isSelected(opt)).length}/{options?.length}</span>
            </Badge>
          </div>

          {options?.map((option, idx) => (
            <div
              key={idx}
              className={`${styles.recipientItem} ${
                isSelected(option) ? `${styles.selectedItem} dark:bg-[#0F1729] dark:text-white` : ""}
                ${recipientType === "client" && option?.employeeCount === 0 ? styles.disabledItem : ""} dark:hover:bg-gray-700 hover:bg-gray-100
                `}
              onClick={() => {
                if (!(recipientType === "client" && option?.employeeCount === 0)) {
                  handleRecipientSelect(option);
                }
              }}
            >
              <div className={styles.recipientInfo}>
                <PersonOutlineOutlinedIcon fontSize="small" className="dark:text-white"/>
                <span className="dark:text-white">{option.label}</span>
              </div>
              {isSelected(option) && (
                <Badge variant="success" className={styles.selectedBadge}>
                  Selected
                </Badge>
              )}
            </div>
          ))}
        </>
      ) : (
        <div className="color-danger" style={{fontSize:"14px", fontWeight:"500"}}>
          {recipientType === "group" ? "You must add at least 1 employee to this group." : "There are no team members active. Please contact your administrator"} 
          </div>
      )}
    </div>
  );
};

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);


const SmsCounter = ({
  message,
  remainingAllowance,
  totalAllowance,
  recipientCount = 1,
  isLimitReached = false,
  smsInfo,
  status,
  totalSegmentsNeeded,
  wouldExceedLimit,
  projectedRemaining,
}) => {

  const getStatusColors = (status) => {
    switch (status) {
      case 'safe':
        return 'text-green-600 dark:text-green-400';
      case 'warning':
        return 'text-orange-500 dark:text-orange-400';
      case 'danger':
        return 'text-red-500 dark:text-red-400';
    }
  };

  const getStatusBgColors = (status) => {
    switch (status) {
      case 'safe':
        return 'bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800';
      case 'warning':
        return 'bg-orange-50 border-orange-200 dark:bg-orange-900/20 dark:border-orange-800';
      case 'danger':
        return 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800';
    }
  };

  return (
    <div className="space-y-3">
      <div className={cn(
        "flex items-center justify-between p-12 rounded-lg border",
        getStatusBgColors(status)
      )}>
        <div className="flex items-center gap-2">
          <MessageSquare size={16} className={getStatusColors(status)} />
          <span className="text-sm font-medium text-muted-foreground">SMS Only</span>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="text-right">
            <span className={cn("text-lg font-semibold", getStatusColors(status))}>
              {smsInfo?.charCount}
            </span>
            <span className="text-sm text-muted-foreground">
              /{smsInfo?.maxCharsForSingleSms}
            </span>
            <span className="text-xs text-muted-foreground ml-4">chars</span>
          </div>
          
          <div className="text-right border-l border-border pl-16">
            <span className={cn("text-lg font-semibold", getStatusColors(status))}>
              {smsInfo?.segmentCount || 0}
            </span>
            <span className="text-xs text-muted-foreground ml-4">
              {smsInfo?.segmentCount === 1 ? 'segment' : 'segments'}
            </span>
          </div>
        </div>
      </div>

      {smsInfo?.isUnicode && (
        <div className="flex items-start gap-2 p-8 rounded-md bg-muted/50 text-sm">
          <Info size={14} className="text-blue-500 mt-2 shrink-0" />
          <span className="text-muted-foreground">
            Using Unicode encoding ({smsInfo?.maxCharsForSingleSms} chars/SMS) due to special characters.
            {smsInfo?.hasEmoji && (
              <span className="block mt-4 text-orange-600 dark:text-orange-400">
                Emojis detected: {smsInfo?.emojiList?.slice(0, 5)?.join(' ')}
                {smsInfo?.emojiList?.length > 5 && ` +${smsInfo?.emojiList?.length - 5} more`}
              </span>
            )}
          </span>
        </div>
      )}

      {smsInfo?.segmentCount > 1 && !isLimitReached && (
        <div className="flex items-start gap-2 p-12 rounded-md bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 text-sm">
          <AlertTriangle size={16} className="text-orange-500 mt-2 shrink-0" />
          <div>
            <p className="font-medium text-orange-700 dark:text-orange-300">
              This message will be sent as {smsInfo?.segmentCount} SMS messages
            </p>
            <p className="text-orange-600 dark:text-orange-400 mt-4">
              Each segment counts against your monthly SMS allowance.
              {recipientCount > 1 && (
                <span className="block">
                  Total SMS usage: {totalSegmentsNeeded} messages ({smsInfo?.segmentCount} segments × {recipientCount} recipients)
                </span>
              )}
            </p>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between p-12 rounded-lg bg-muted/30 border border-border">
        <div className="text-sm">
          <span className="text-muted-foreground">Monthly SMS Allowance</span>
        </div>
        <div className="flex items-center gap-2">
          <span className={cn(
            "font-semibold",
            isLimitReached ? "text-red-500" : wouldExceedLimit ? "text-orange-500" : "text-foreground"
          )}>
            {remainingAllowance.toLocaleString()}
          </span>
          <span className="text-muted-foreground">/</span>
          <span className="text-muted-foreground">{totalAllowance.toLocaleString()}</span>
          <span className="text-xs text-muted-foreground">remaining</span>
        </div>
      </div>

      {smsInfo?.segmentCount > 0 && !isLimitReached && !wouldExceedLimit && (
        <div className="text-xs text-muted-foreground text-right">
          After sending: {projectedRemaining.toLocaleString()} SMS remaining this month
        </div>
      )}

      {wouldExceedLimit && !isLimitReached && (
        <div className="flex items-start gap-2 p-12 rounded-md bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-sm">
          <AlertTriangle size={16} className="text-red-500 mt-2 shrink-0" />
          <div>
            <p className="font-medium text-red-700 dark:text-red-300">
              Insufficient SMS allowance
            </p>
            <p className="text-red-600 dark:text-red-400 mt-4">
              This message requires {totalSegmentsNeeded} SMS but you only have {remainingAllowance} remaining.
              Reduce message length or recipient count, or Email/Push will still be sent.
            </p>
          </div>
        </div>
      )}

      {isLimitReached && (
        <div className="flex items-start gap-2 p-12 rounded-md bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-sm">
          <AlertTriangle size={16} className="text-red-500 mt-2 shrink-0" />
          <div>
            <p className="font-medium text-red-700 dark:text-red-300">
              SMS limit reached
            </p>
            <p className="text-red-600 dark:text-red-400 mt-4">
              Your SMS limit for this month has been reached. SMS will resume when your limit resets.
              Email and Push notifications will still be sent if selected.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};



const NotificationForm = ({
  isMobile,
  type,
  options,
  formdata,
  audienceName,
  setAudienceName,
  selectedNotificationTypes,
  messageOptionsList,
  scheduled,
  scheduleDate,
  scheduleTime,
  smsPackageLimits,
  isSmsLimitReached,
  smsRemainingAllowance,
  smsInfo,
  status,
  totalSegmentsNeeded,
  wouldExceedLimit,
  projectedRemaining,
  setAudienceList,
  setFormData,
  setType,
  handlefieldChange,
  handlefieldChangenewm,
  handleNotificationTypeChange,
  handleSelectAllTypes,
  onScheduledChange,
  onScheduledDateChange,
  onScheduledTimeChange,
}) => {
  
  const TypeOptions = [
    { label: "Name", value: "employee" },
    { label: "Group", value: "group" },
  ];
  const isSmsSelected = selectedNotificationTypes.includes("Push");
  const selectedRecipients =
    type === "employee"
      ? formdata?.selectedEmployees || []
      : type === "group"
      ? formdata?.selectedGroup
        ? formdata.selectedGroup
        : []
      : [];

  return (
      <div
        className={
          isMobile
            ? "d-flex flex-direction-column w-100"
            : "d-flex flex-space-between w-100"
        }
      >
        <div style={{ width: isMobile ? "100%" : "65%" }}>
          <Card
            className={`${styles.cardStyle} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
          >
            <h3 className="p-20 d-flex flex-center">
              <RecipientType recipientType={type} />{" "}
              <span
                style={{ fontSize: "18px", fontWeight: "600" }}
                className="ml-8 text-foreground"
              >
                Select Recipients
              </span>
            </h3>
            <CardContent className="ph-20 pb-20 pt-0">
              <h4
                className="mv-5 text-foreground"
                style={{ fontSize: "14px", fontWeight: "500" }}
              >
                Employee by
              </h4>

              <div className="mb-16">
                <SingleSelectNew
                  value={type}
                  name={"type"}
                  contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                  itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                  onChange={(value) => {
                    setAudienceList([]);
                    setAudienceName([]);
                    const newType = value;
                    setType(newType);

                    if (
                      formdata?.selectedEmployees ||
                      formdata?.selectedClient ||
                      formdata?.selectedGroup
                    ) {
                      setFormData((prev) => ({
                        ...prev,
                        selectedEmployees: undefined,
                        selectedClient: undefined,
                        selectedGroup: undefined,
                      }));
                    }
                  }}
                  options={TypeOptions}
                />
              </div>

              <div>
                <h3
                  style={{ fontSize: "14px", fontWeight: "500" }}
                  className="text-foreground"
                >
                  Available {type === "employee" ? "Employees" : "Groups"}
                </h3>
                <RecipientList
                  options={options}
                  formdata={formdata}
                  recipientType={type}
                  handlefieldChange={handlefieldChange}
                  selectedRecipients={selectedRecipients}
                />

                <div
                  className="mt-10 text-foreground"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    // color: "#020817",
                  }}
                >{`Selected Recipients (${
                  audienceName?.length > 0 ? audienceName?.length : 0
                })`}</div>
                {audienceName?.length === 0 && (
                  <div
                    className="mt-10"
                    style={{
                      color: "#64738B",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    No recipients selected{" "}
                  </div>
                )}
              </div>
            </CardContent>
          </Card>

          <Card
            className={`${styles.cardStyle} mv-30 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
          >
            <div
              className="d-flex flex-center"
              style={{ padding: "24px 24px 12px" }}
            >
              <ChatBubbleOutlineOutlinedIcon
                style={{ color: "rgb(59 130 246 / 1)" }}
                className="mr-8"
              />
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                }}
                className="text-foreground"
              >
                {" "}
                Message Details
              </span>
            </div>
            <CardContent style={{ padding: "12px 24px 24px 24px" }}>
              <div className={`${styles.container} mb-10`}>
                <div className={styles.header}>
                  <label className={`${styles.label} dark:text-white`}>
                    Notification Types
                  </label>
                  <button
                    type="button"
                    className={styles.selectAllBtn}
                    onClick={handleSelectAllTypes}
                  >
                    {selectedNotificationTypes?.length ===
                    messageOptionsList?.length
                      ? "Deselect All"
                      : "Select All"}
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-10">
                  {messageOptionsList?.map((type) => (
                    <div
                      key={type.value}
                      className={`flex items-center space-x-2 border rounded-md p-12 cursor-pointer ${
                        selectedNotificationTypes?.includes(type.value)
                          ? "border-blue-500 bg-blue-50 dark:bg-[#0F1729] dark:text-white"
                          : "border-gray-200 hover:border-gray-300"
                      }`}
                      onClick={() => {
                        const isBlocked = (type.value === "Push" && isSmsLimitReached);
                        if (type?.enabled && !isBlocked) {
                          handleNotificationTypeChange(type.value);
                        }
                      }}
                    >
                      <Checkbox
                        id={`type-${type.id}`}
                        checked={selectedNotificationTypes?.includes(
                          type.value
                        )}
                        disabled={!type.enabled || (type.value === "Push" && isSmsLimitReached)}
                        onCheckedChange={() => {
                          const isBlocked = (type.value === "Push" && isSmsLimitReached);
                          if (type.enabled && !isBlocked) {
                            handleNotificationTypeChange(type.value);
                          }
                        }}
                      />
                      <div className="flex flex-1 items-center">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <span className="mr-5 dark:text-white">
                            {type?.icon}
                          </span>{" "}
                          <span className="dark:text-white">{type?.label}</span>
                        </label>
                      </div>
                    </div>
                  ))}
                </div>

                {selectedNotificationTypes?.length === 0 && (
                  <p className="color-danger">
                    Please select at least one notification type
                  </p>
                )}
              </div>

              <Typography
                variant="body"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                }}
                className="text-[#020817] dark:text-white"
              >
                Subject
              </Typography>
              <div className="mt-8 mb-12">
                <Input
                  id="subject"
                  placeholder="Enter notification subject"
                  className="mt-1"
                  value={formdata?.subject ? formdata?.subject : ""}
                  onChange={(e) =>
                    handlefieldChangenewm("subject", e.target.value)
                  }
                />
              </div>

              <Typography
                variant="body"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                }}
                className="text-[#020817] dark:text-white"
              >
                Message
              </Typography>
              <div className="mt-8 mb-12">
                <Textarea
                  id="message"
                  placeholder="Type your message here"
                  className="mt-1 min-h-[150px]"
                  value={formdata?.message ? formdata?.message : ""}
                  onChange={(e) =>
                    handlefieldChangenewm("message", e.target.value)
                  }
                />
              </div>
              
              {isSmsSelected && (
                <SmsCounter
                    message={formdata?.message || ""}
                    remainingAllowance={smsRemainingAllowance}
                    totalAllowance={smsPackageLimits || 0}
                    recipientCount={selectedRecipients?.length || 1}
                    isLimitReached={isSmsLimitReached}
                    smsInfo={smsInfo}
                    status={status}
                    totalSegmentsNeeded={totalSegmentsNeeded}
                    wouldExceedLimit={wouldExceedLimit}
                    projectedRemaining={projectedRemaining}
                />
              )}

              <div className={`${styles.scheduleContainer} mt-5`}>
                <div className={styles.scheduleHeader}>
                  <div className={styles.scheduleLeft}>
                    <AccessTimeOutlinedIcon className={styles.clockIcon} />
                    <h4
                      htmlFor="scheduled"
                      className="text-[#020817] dark:text-white"
                    >
                      Schedule for later
                    </h4>
                  </div>
                  <AntSwitch
                    checked={scheduled}
                    onChange={onScheduledChange}
                    color="primary"
                    name="switchStatus"
                    inputProps={{ "aria-label": "switchStatus" }}
                  />
                </div>

                {scheduled && (
                  <div className={styles.scheduleGrid}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <div>
                        <h4
                          htmlFor="date"
                          className="mv-5 text-[#020817] dark:text-white"
                        >
                          Date
                        </h4>
                        <DatePicker
                          value={scheduleDate ? moment(scheduleDate) : null}
                          onChange={(newValue) => {
                            onScheduledDateChange(
                              newValue ? newValue.format("YYYY-MM-DD") : ""
                            );
                          }}
                          disablePast={true}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </div>

                      <div>
                        <h4
                          htmlFor="time"
                          className="mv-5 text-[#020817] dark:text-white"
                        >
                          Time
                        </h4>
                        <TimePicker
                          value={
                            scheduleTime ? moment(scheduleTime, "HH:mm") : null
                          }
                          onChange={(newValue) => {
                            onScheduledTimeChange(
                              newValue ? newValue.format("HH:mm") : ""
                            );
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              sx: {
                                "& .MuiInputBase-input": {
                                  height: "30px",
                                  color: "white",
                                  backgroundColor: "transparent",
                                },
                                "& .MuiOutlinedInput-root": {
                                  height: "40px",
                                  borderRadius: "8px",
                                },
                              },
                              className: `${styles.inputField} dark:text-white dark:bg-[#0F1729]`,
                            },
                          }}
                        />
                      </div>
                    </LocalizationProvider>
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
        <div style={{ width: isMobile ? "100%" : "32%" }}>
          <Card
            className={`${styles.card} ${styles.cardStyle} mv-30 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
            style={{ minWidth: "100%" }}
          >
            <div className={styles.cardHeader}>
              <div className={styles.cardTitle}>
                <NotificationsNoneOutlinedIcon
                  size={18}
                  className={styles.notificationIcon}
                />
                <span className="dark:text-white">Notification Preview</span>
              </div>
            </div>

            <CardContent style={{ padding: "0px 24px 24px 24px" }}>
              <div className={styles.contentWrapper}>
                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>Notification Types</h3>
                  <div className={styles.badgeContainer}>
                    {selectedNotificationTypes?.includes("Email") && (
                      <Badge className={styles.emailBadge}>
                        <EmailOutlinedIcon fontSize="small" /> Email
                      </Badge>
                    )}
                    {selectedNotificationTypes?.includes("Push") && (
                      <Badge className={styles.smsBadge}>
                        <ChatBubbleOutlineOutlinedIcon fontSize="small" /> SMS
                      </Badge>
                    )}
                    {selectedNotificationTypes?.includes(
                      "PushNotification"
                    ) && (
                      <Badge className={styles.pushBadge}>
                        <NotificationsNoneOutlinedIcon fontSize="small" /> Push
                      </Badge>
                    )}
                    {selectedNotificationTypes?.length === 0 && (
                      <span className={styles.emptyText}>
                        No notification types selected
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>Subject</h3>
                  <div className={`${styles.box} dark:bg-[#0F1729]`}>
                    {formdata?.subject ? (
                      <span className="dark:text-white">
                        {formdata?.subject}
                      </span>
                    ) : (
                      <span className={`${styles.emptyText} dark:text-white`}>
                        No subject
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>Message</h3>
                  <div
                    className={`${styles.box} ${styles.messageBox} dark:bg-[#0F1729]`}
                  >
                    {formdata?.message ? (
                      <span className="dark:text-white">
                        {formdata?.message}
                      </span>
                    ) : (
                      <span className={`${styles.emptyText} dark:text-white`}>
                        No message
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>
                    Recipients (
                    {audienceName?.length > 0 ? audienceName?.length : 0})
                  </h3>
                  <div className={styles.badgeContainer}>
                    {audienceName?.length > 0 ? (
                      audienceName?.slice(0, 3).map((recipient) => (
                        <Badge
                          key={recipient}
                          variant="outline"
                          className={`${styles.recipientBadge} dark:text-white`}
                        >
                          <PersonOutlineOutlinedIcon fontSize="small" />{" "}
                          {recipient}
                        </Badge>
                      ))
                    ) : (
                      <span className={styles.emptyText}>
                        No recipients selected
                      </span>
                    )}
                    {audienceName?.length > 3 && (
                      <Badge
                        variant="outline"
                        className={`${styles.recipientBadge} dark:text-white`}
                      >
                        <PersonOutlineOutlinedIcon fontSize="small" /> +
                        {audienceName?.length - 3} more
                      </Badge>
                    )}
                  </div>
                </div>

                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>Delivery</h3>
                  <div className={styles.deliveryInfo}>
                    {scheduled ? (
                      <>
                        <AccessTimeOutlinedIcon
                          fontSize="small"
                          className={styles.clockIcon}
                        />
                        <span className="dark:text-white">
                          {`Scheduled for  ${scheduleDate} - ${scheduleTime}`}
                        </span>
                      </>
                    ) : (
                      <>
                        <Badge className={styles.immediateBadge}>
                          Immediate
                        </Badge>
                        <span className={styles.deliveryText}>
                          Will be sent immediately
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
  );
};


export default NotificationForm;